module.exports = __webpack_public_path__ + "assets/fe727dab38900ee5dead3d95bf1a934a.mp3";